var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from "mobx";
import { ignore } from "mobx-sync";
import { O } from "../Utils/Store/MobX.js";
export class WVCState {
    constructor() {
        this.notificationMessages = [];
        this.webSocketConnected = false;
        makeObservable(this);
    }
}
__decorate([
    O,
    ignore
], WVCState.prototype, "notificationMessages", void 0);
__decorate([
    O,
    ignore
], WVCState.prototype, "webSocketConnected", void 0);
__decorate([
    O,
    ignore
], WVCState.prototype, "webSocketLastDCTime", void 0);
export const wvc_store = new WVCState();
//# sourceMappingURL=WVCStore.js.map